import React from "react";
import ScrollToTop from "./components/Pages/ScrollToTop";
import RoutePath from "./components/Routes/RoutePath";
import Layout from "./components/Layout/Layout";
import { AuthProvider } from "./components/Auth/AuthProvider";

function App() {
  return (
    <AuthProvider>
      <ScrollToTop /> {/* Put this here */}
      <Layout>
        <RoutePath />
      </Layout>
    </AuthProvider>
  );
}

export default App;
